import { Logo } from "@kirvanobr/logo";
import * as S from "@styles/error-styles";
import Image from "next/image";

import CustomThemeProvider from "@providers/CustomThemeProvider";
import { useTheme } from "next-themes";
import Dark404 from "public/assets/error-ilustrations/dark/404-dark.svg";
import Light404 from "public/assets/error-ilustrations/light/404-light.svg";

export default function Custom404() {
  const { theme } = useTheme();
  return (
    <CustomThemeProvider>
      <S.Container>
        <div>
          <div className="logo">
            <Logo variant="full" fontSize={24} className="text-foreground" />
          </div>
          <span>
            <h1 className="title">Ooopss...</h1>
            <h2 className="subtitle">404. Isso é um erro.</h2>

            <p className="text">Esta página não existe ou foi removida.</p>
            <p className="text gray-text">Isso é tudo que sabemos.</p>
          </span>
        </div>

        <div className="ilustration-404">
          <Image alt="Page not found" src={theme === "dark" ? Dark404 : Light404} fill sizes="100%" />
        </div>
      </S.Container>
    </CustomThemeProvider>
  );
}
